module.exports = __webpack_public_path__ + "img/card-btn-hover.69d3d3be.png";